module.exports = __webpack_public_path__ + "static/media/Virtual-Glass-Wordmark-OneLine_Clear.92369897.png";